import apiClient from '@/services/axios';

export async function get(userId) {
  const response = await apiClient.get(`/users/${userId}/firebase-auth-info`);

  if (response) {
    return response.data;
  }

  throw new Error('Unable to get user Firebase auth info.');
}

